module.exports = __webpack_public_path__ + "media/images/client-34-934093beff691478f9f82d71f0c139b9.png";